import { axiosInstance } from './axios';
import { DEMO_MODE } from './demoMode';
import { resolveMockRequest } from '../mocks/mockServer';

/**
 * Adapts our shared axios instance (cookies, XSRF, base URL already wired)
 * into an RTK Query baseQuery, so every feature slice's API just declares
 * endpoints — no per-slice fetch/axios boilerplate.
 *
 * In demo mode (see ./demoMode) requests are routed to an in-memory mock
 * API instead of axios, so the whole app works without the Laravel
 * backend running. Every feature slice goes through this one function, so
 * that's the only place demo mode needs to be handled.
 */
export const axiosBaseQuery =
  () =>
  async ({ url, method = 'GET', data, params, headers }) => {
    try {
      const result = DEMO_MODE
        ? await resolveMockRequest({ url, method, data, params })
        : await axiosInstance({ url, method, data, params, headers });
      return { data: result.data };
    } catch (axiosError) {
      const err = axiosError;
      return {
        error: {
          status: err.status ?? err.response?.status,
          data: err.data ?? err.response?.data ?? err.message,
        },
      };
    }
  };

export default axiosBaseQuery;
